import * as React from 'react';
// var ReactDom = require('react-dom');
import { Theme } from '@material-ui/core/styles';
import withStyles, { WithStyles, StyleRules, ClassNameMap } from '@material-ui/core/styles/withStyles';
import { IconButton } from '@material-ui/core'
import { Tooltip } from '@material-ui/core';
import { Typography } from '@material-ui/core';
import * as Dropzone from 'react-dropzone/dist/index';
import { red, green, grey } from '@material-ui/core/colors';
import ImageViewer from './image-viewer'
import PortalUserContext from '~common/lib/portal-user-context';
import { Icon } from '@material-ui/core';
import * as request from 'superagent';
import ErrorView from '~common/components/error-view';


import {
    FormControl,
    FormControlLabel,
    FormHelperText,
    Select,
    MenuItem
} from '@material-ui/core'
import classNames from 'classnames';
import { rawListeners } from 'superagent';



const styles = (theme: Theme): StyleRules => ({
    container: {
        marginRight: 10
    },
    selector: {
        width: 300
    },
    dropzone: {
        border: '1px dashed #ccc',
        padding: 15,
        marginLeft: 10,
        marginTop: 0,
        backgroundColor: grey[100],
        flex: 'auto',
        display: 'flex',
        'align-items': 'center',
        'justify-content': 'center',
        cursor: 'pointer',
        minWidth: 240
    },
    dropzoneError: {
        border: '1px dashed #ccc',
        padding: 15,
        marginLeft: 10,
        marginTop: 0,
        backgroundColor: red[100],
        flex: 'auto',
        display: 'flex',
        'align-items': 'center',
        'justify-content': 'center',
        cursor: 'pointer',
        minWidth: 240
    },
    dropzoneMin: {
        border: '0px dashed #ccc',
        paddingTop: 8,
        marginLeft: 10,
        marginTop: 0,
        // backgroundColor: grey[100],
        width: '2rem',
        height: '2rem',
        display: 'flex',
        'align-items': 'center',
        'justify-content': 'center',
        cursor: 'pointer'
    },
    dropzoneActive: {
        backgroundColor: green[100]
    },
    dropzoneReject: {
        backgroundColor: red[100]
    },
    dropzoneDisabled: {
        backgroundColor: grey[400]
    },
    historyIndicator: {
        borderBottom: '1px solid #1614b3'
    }
})

var MAX_FILE_SIZE = 5242880;

type State = {
    rawData?: any
    data: any
    url?: string
    currentAttachment?: any
    error?: any
    currentPage: number
    pageCount: number
    status: 'ready' | 'uploadingNewDocument' | 'uploadingNewVersion' | 'uploaded';
    accept?: string;
    isDragReject?: boolean;
    acceptedFiles: Array<any>;
    currentIndex?: number;
};


interface Props extends React.HTMLProps<HTMLDivElement> {
    data: any
    definition: any
    maxSize?: number;
    minSize?: number;
    helperText?: string;
    accept?: string;
    error?: boolean;
    url?: string
    onImageListChange: (attachments: any) => void;
    readOnly?: boolean;
    policyMessages?:Array<any>;
    path?: string;
}


class ImageList extends React.Component<Props & WithStyles<keyof typeof styles>, State> {
    constructor(props: Props) {
        super(props, {});

        let list: Array<any> = [];
        let ca = {};
        if (props && props.data && this.props.data.list) {
            list = this.parseRawData(props.data.list);
            if (list.length > 0) {
                ca = list[0].value;
            }
        }
        this.state = {
            status: "ready",
            rawData: props.data,
            data: list,
            currentPage: 0,
            pageCount: 0,
            currentAttachment: ca,
            accept: props.accept || 'image/gif, image/jpeg, application/pdf, image/png, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, image/tiff, text/plain, text/csv, application/vnd.ms-outlook, message/rfc822, .msg',
            acceptedFiles: [],
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps: any, oldProps: any) {
        const emptyState = {
            data: [],
            currentPage: 0,
            pageCount: 0,
            currentAttachment: null,
            url: "",
            rawData: { list: null }
        }

        // If there is data and nextProps is null, we need to clear out existing attachments
        if (nextProps && (!nextProps.data || (nextProps.data.list || []).length == 0) && this.state.data && this.state.data.length > 0) {
            this.setState(emptyState)
        } else if (nextProps && nextProps.data && nextProps.data.list) {
            let list: Array<any> = [];
            let ca = {};
            list = this.parseRawData(nextProps.data.list);

            if (list.length > 0) {
                ca = list[(this.state.currentIndex || 0)].value;
            }
            
            if (ca["storageKey"] != (this.state.currentAttachment || {}).storageKey || this.state.data.length != nextProps.data.list.length) {
                this.setState({
                    status: "ready",
                    rawData: nextProps.data,
                    data: list,
                    currentPage: 0,
                    pageCount: 0,
                    currentAttachment: ca
                }, () => {
                    this.renderAttachment(ca, 1)
                })
            } else {
                if (!ca["storageKey"]) {
                    this.setState(emptyState)
                }
            }

        } else {
            this.setState(emptyState)
        }
    }

    componentDidMount() {
        if (this.state.currentAttachment && this.state.currentAttachment.storageKey) {
            this.renderAttachment(this.state.currentAttachment, 1)
        }
    }

    onDocumentSelectionChange = (list: any, b: any) => {
        if (list && list.target && list.target.value) {
            if (typeof (list.target.value) == "object") {
                list.target.value = JSON.stringify(list.target.value)
            }

            const obj = JSON.parse(list.target.value)

            const currentIndex:number = this.state.rawData.list.findIndex(function(a){
                return a.active.storageKey == obj.storageKey
            })
            this.setState({
                currentIndex: currentIndex
            }, ()=>{
                this.renderAttachment(obj, 1);
            })
            
        }
    }

    renderAttachment = (attachment: any, page: number) => {
        const { storageKey, fileName, pageCount } = attachment;
        const { currentAttachment, currentPage } = this.state;

        if (storageKey && currentPage != page || storageKey != (currentAttachment || {}).storageKey) {
            let openInWindow = false;
            let url = ""
            
            const currentIndex:number = this.state.rawData.list.findIndex(function(a){
                return a.active.storageKey == storageKey
            })
            switch (attachment.contentType) {
                case "application/pdf":
                case "image/png":
                case "image/gif":
                case "image/jpeg":
                case "image/tiff":
                    url = `/api/attachment-storage/${storageKey}/${page}`
                    break;
                default:
                    openInWindow = true
                    url = `/api/attachment-storage/${storageKey}/raw?fileName=${attachment.fileName}`
                    break;
            }

            if (!openInWindow && url != "") {
                this.setState({
                    // currentIndex: currentIndex,
                    url: url,
                    currentAttachment: attachment,
                    currentPage: page,
                    pageCount: attachment.pageCount,
                })
            } else if (openInWindow && url != "") {
                window.open(url)
                this.setState({
                    // currentIndex: currentIndex,
                    currentAttachment: attachment,
                    currentPage: 1,
                    pageCount: 1,
                    url: ""
                })
            }
        }
    }

    firstPage = () => {
        const { currentPage, currentAttachment } = this.state;
        if (currentAttachment) {
            this.renderAttachment(currentAttachment, 1)
        }
    }

    previousPage = () => {
        const { currentPage, currentAttachment } = this.state;
        if (currentAttachment && currentPage - 1 > 0) {
            this.renderAttachment(currentAttachment, currentPage - 1)
        }
    }

    nextPage = () => {
        const { currentPage, currentAttachment } = this.state;
        if (currentAttachment && currentPage < currentAttachment.pageCount) {
            this.renderAttachment(currentAttachment, currentPage + 1)
        }
    }

    lastPage = () => {
        const { currentPage, currentAttachment } = this.state;
        if (currentAttachment) {
            this.renderAttachment(currentAttachment, currentAttachment.pageCount)
        }
    }

    parseRawData = (data: any) => {
        let list: Array<any> = [];
        let ca = {};

        if (data) {
            data.forEach((d) => {
                if (d.active) {
                    list.push({ label: d.active.fileName, value: d.active })
                }
            })
        }

        return list;
    }
    onDrop = (acceptedFiles: Array<any>, rejectedFiles: Array<any>) => {
        // const { parse } = this.props;
        if (rejectedFiles && rejectedFiles.length > 0) {
            // 06/28/2021 MV: Not sure why this is commented out but leaving it commented out for now
            //   if (this.props.onFileReject) {
            //     this.props.onFileReject(rejectedFiles);
            //   }
            rejectedFiles.forEach((f: any) => {
                if (f.size > (this.props.maxSize || MAX_FILE_SIZE)) {
                    this.setState({
                        isDragReject: true,
                        status: 'ready',
                        error: `File size cannot exceed ${(
                            (this.props.maxSize || MAX_FILE_SIZE) /
                            (1024 * 1024)
                        ).toFixed(0)}MB`
                    });
                    return
                } else {
                    this.setState({
                        isDragReject: true,
                        status: 'ready',
                        error: "Invalid file type"
                    })
                }
            });
        }

        if (acceptedFiles && acceptedFiles.length > 0) {
            this.setState({ status: 'uploadingNewDocument' }, () => {
                const { rawData } = this.state;

                for (let f of acceptedFiles) {
                    // let parseFlag = '?parse=true';
                    let parseFlag = `?opts={"forcePageCount":true, "extractPages":true, "density":200, "monochrome":true}`
                    if (f.type.indexOf("vnd.openxmlformats-officedocument") > -1) {
                        parseFlag = '?parse=false';
                    }
                    request
                        .post((this.props.url || `/api/attachment-storage`) + parseFlag)
                        .attach(f.name, f)
                        .then((response) => {
                            if (response.ok) {
                                const att = {
                                    fileName: f.name,
                                    contentType: f.type,
                                    size: f.size,
                                    pageCount: response.body.pageCount,
                                    storageKey: response.body.storageKey,
                                    data: response.body,
                                    uploadedOn: new Date(),
                                    uploadedBy: {
                                        name: PortalUserContext.userContext.displayName,
                                        email: PortalUserContext.userContext.email
                                    },
                                };
                                rawData.list = rawData.list || [] //{}
                                if (rawData.list) {
                                    rawData.list.push({ active: att });
                                }
                                var { acceptedFiles } = this.state;
                                acceptedFiles.push(att.storageKey);
                                this.props.onImageListChange(rawData)

                                this.setState({currentIndex: rawData.list.length, currentPage: 1, pageCount: att.data.pageCount, acceptedFiles: acceptedFiles, rawData: rawData, data: this.parseRawData(rawData.list), status: 'ready', error: null, isDragReject: false }, () => {
                                    this.onDocumentSelectionChange({
                                        target: { value: att }
                                    }, null)
                                });
                            } else {
                                // Report the error to the user
                                this.setState({
                                    status: 'ready',
                                    error: 'An error occurred uploading the document'
                                });
                            }
                        })
                        .catch((err) => {
                            this.setState({
                                status: 'ready',
                                error: 'An error occurred uploading the document',
                                isDragReject: true
                            });
                        });
                }
            });
        }
    };

    export = () => {
        const { currentAttachment } = this.state;

        const { fileName, storageKey } = currentAttachment;
        window.open(`/api/attachment-storage/${storageKey}/raw?fileName=${fileName}`)
    }

    removeAttachment = () => {
        const { currentAttachment, rawData } = this.state;
        let newList: Array<any> = [];
        let ca = {};

        if (rawData) {
            rawData.list.forEach((att: any) => {
                if (att.active) {
                    if (att.active.storageKey != currentAttachment.storageKey) {
                        newList.push(att);
                    }
                }
            })
        }

        rawData.list = newList;

        this.setState({
            rawData: rawData,
            data: this.parseRawData(rawData.list),
            currentAttachment: null,
            url: null,
            currentPage: 0,
            pageCount: 0,
        });
    }

    getHistoryPolicy = (idx: number) => {
        var {policyMessages, path} = this.props
        var historyEntry
        (policyMessages||[]).forEach((pm:any)=>{
            if (pm.path && pm.path.indexOf(path) > -1 && pm.severity == 4) {
                var parts = pm.path.split("/")
                var lastPart = parseInt(parts[parts.length -1])
                if (!isNaN(lastPart) && lastPart == idx) {
                    historyEntry = pm
                }
            }
        })
        return historyEntry
    }

    render() {
        const { acceptedFiles, data, currentAttachment, currentPage, pageCount, error, isDragReject } = this.state;
        const { definition, minSize, maxSize, helperText, policyMessages, path } = this.props;
        const { classes }: { classes: ClassNameMap } = this.props;
        var errorView: any = null;

        if (error) {
            errorView = <ErrorView onClose={() => {
                this.setState({
                    error: null
                })
            }} classes={{}} error={error} />;
        }

        let dzClass = classes.dropzone
        let prompt = 'Drop file to upload new document';
        if (helperText) {
            if (helperText == 'Field required' || helperText == 'At least one document is required') {
                prompt = "At least one document is required"
                dzClass = classes.dropzoneError;
            } else {
                prompt = helperText
            }
        }
        if (this.props.error) {
            prompt = helperText
            dzClass = classes.dropzoneError;
        }

        var hasAttachment: bool = false

        var hasHistoryPolicy: bool = false

        if (policyMessages && policyMessages.length > 0) {
            policyMessages.forEach((pm:any)=>{
                if (pm.path && pm.path.indexOf(path) > -1 && pm.severity == 4) {
                    hasHistoryPolicy = true
                }
            })
        }

        return (
            <div className={classes.container}>
                {errorView}
                <FormControl
                    style={{ width: '100%' }}>
                    <div style={{ width: '100%', display: 'flex' }}>
                        <Select
                            inputProps={{ tabIndex: definition.tabIndex || -1 }}
                            value={JSON.stringify(currentAttachment)}
                            name={definition.key}
                            required={definition.mode == "Required"}
                            error={this.props.error}
                            onChange={this.onDocumentSelectionChange}
                            multiple={false}
                            className={hasHistoryPolicy ? classNames(classes.selector, classes.historyIndicator) : classes.selector}
                            MenuProps={{
                                PaperProps: {
                                    style: { maxHeight: 300 }
                                }
                            }}
                        >
                            {data && data.map((c: any, idx: number) => {
                                hasAttachment = true
                                var historyMessage
                                var history = this.getHistoryPolicy(idx)
                                if (history) {
                                    historyMessage = history.title
                                }
                                var label = c.label
                                if (historyMessage) {
                                    label = `${label} ${historyMessage}`
                                }
                                return (
                                    <MenuItem
                                        style={{color: historyMessage ? "#1614b3" : "default"}}
                                        id={`doc_${idx}`}
                                        key={`doc_${idx}`}
                                        value={JSON.stringify(c.value)}>
                                        {label}
                                    </MenuItem>
                                );
                            })}

                        </Select>

                        {definition.mode == "Required" && <i style={{ color: 'red', marginTop: 20 }}>*</i>}

                        {!this.props.readOnly && definition.mode != "Display" && definition.mode != "Read Only" &&
                            <Dropzone
                                multiple={false}
                                minSize={minSize}
                                maxSize={maxSize || MAX_FILE_SIZE}
                                accept={this.state.accept}
                                className={dzClass}
                                activeClassName={classes.dropzoneActive}
                                rejectClassName={classes.dropzoneReject}
                                disabledClassName={classes.dropzoneDisabled}
                                onDrop={this.onDrop}
                                disabled={this.props.readOnly || this.props.readOnly}
                                inputProps={{ tabIndex: definition.tabIndex || -1 }}
                            >
                                {(state: {
                                    isDragActive: boolean;
                                    isDragReject: boolean;
                                    acceptedFiles: Array<any>;
                                    rejectedFiles: Array<any>;
                                    draggedFiles: Array<any>;
                                }) => {
                                    if (isDragReject) {
                                        if (state.rejectedFiles.length > 1 && !this.props.multiple) {
                                            return 'Multiple file drop is not permitted';
                                        }
                                    }
                                    return prompt;
                                }}
                            </Dropzone>
                        }
                    </div>
                </FormControl>

                {hasAttachment && <ImageViewer
                    onDelete={acceptedFiles.indexOf((currentAttachment || {}).storageKey) > -1 ? this.removeAttachment : null}
                    url={this.state.url}
                    classes={{}}
                    export={this.export}
                    firstPage={this.firstPage}
                    previousPage={this.previousPage}
                    nextPage={this.nextPage}
                    lastPage={this.lastPage}
                    pageCount={pageCount}
                    currentPage={currentPage}
                    rotation={0} />
                }
                {!hasAttachment && <div><b>There are no supporting documents</b></div>}
            </div >
        )
    }


}

export default withStyles(styles)(ImageList);
